import * as React from "react"
import {
  Auth0Config,
  Auth0ConfigFragFragment,
  Booker as BOOKER,
  BookingPaymentLink,
  PaymentLinkFragment,
  UseBookingPaymentLink,
} from "../graphql/queries"
import {auth0Url, redirectTo} from "./Auth0LockLink"
import {GraphQL} from "../graphql"
import {Loader} from "semantic-ui-react"
import {errorUnionToEither, handleError, OrError} from "../graphql/errors"
import {liftEitherInOption, loading, Loading, loadingIfNull, nullableToLeft, ready} from "../tsutil"
import {history, WithModalStore} from "../App"
import {Booker} from "../model/BookingTypes"

class PayerSignupRender extends React.Component<LoadedProps, {loading: boolean}> {
  constructor(props: LoadedProps) {
    super(props)
    this.state = {loading: true}
  }

  async componentDidMount() {
    const {id, auth0Config, modalStore, booker, paymentLink} = this.props
    if (booker === null) {
      redirectTo(auth0Url(auth0Config, paymentLink.toEmail, "signUp", true, true))
    } else {
      const result = await modalStore.applyModal({
        error: (m) => ["Payer registration failed", m],
        action: () => becomePayer(id),
      })
      if (result.isRight()) {
        history.push("/booking/" + paymentLink.bookingNumber)
      }
      this.setState({loading: false})
    }
  }

  render() {
    return this.state.loading ? <Loader active /> : null
  }
}

interface LoadingProps extends OwnProps {
  booker: Loading<Booker | null>
  auth0Config: Loading<Auth0ConfigFragFragment>
  paymentLink: Loading<PaymentLinkFragment>
}

interface LoadedProps extends OwnProps {
  booker: Booker | null
  auth0Config: Auth0ConfigFragFragment
  paymentLink: PaymentLinkFragment
}

function PayerSignupLoader(props: LoadingProps) {
  if (props.auth0Config.isSome() && props.booker.isSome() && props.paymentLink.isSome()) {
    return (
      <PayerSignupRender
        {...props}
        auth0Config={props.auth0Config.value}
        booker={props.booker.value}
        paymentLink={props.paymentLink.value}
      />
    )
  } else {
    return <Loader active />
  }
}

function PayerSignupWithAuth0Config(props: LoadingProps) {
  return (
    <GraphQL.Query
      query={Auth0Config}
      variables={{}}
      render={({data}) => {
        return (
          <PayerSignupLoader
            {...props}
            auth0Config={loadingIfNull(data).map((x) => x.auth0Config)}
          />
        )
      }}
    />
  )
}

function PayerSignupWithBooker(props: LoadingProps) {
  return (
    <GraphQL.Query
      query={BOOKER}
      variables={{}}
      render={({data}) => {
        const booker = liftEitherInOption(
          loadingIfNull(data).map((x) => errorUnionToEither(x.booker)),
        )
        return handleError(booker, (booker) => (
          <PayerSignupWithAuth0Config {...props} booker={booker.map((x) => x.booker)} />
        ))
      }}
    />
  )
}

function PayerSignupWithPaymentLink(props: LoadingProps) {
  const {id} = props
  return (
    <GraphQL.Query
      query={BookingPaymentLink}
      variables={{secretId: id}}
      render={({data}) => {
        const Next = (link: Loading<PaymentLinkFragment>) => (
          <PayerSignupWithBooker {...props} paymentLink={link} />
        )
        return data
          ? handleError(errorUnionToEither(data.bookingPaymentLink), (link) => Next(ready(link)))
          : Next(loading)
      }}
    />
  )
}

interface OwnProps extends WithModalStore {
  id: string
}

async function becomePayer(secretId: string): Promise<OrError<void>> {
  const result = await GraphQL.mutate(UseBookingPaymentLink, {secretId})
  return nullableToLeft(result.useBookingPaymentLink)
}

export function PayerSignup(props: OwnProps) {
  return (
    <PayerSignupWithPaymentLink
      {...props}
      paymentLink={loading}
      auth0Config={loading}
      booker={loading}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/PayerSignup.tsx